import React, { Component } from 'react';
import { connect } from 'react-redux'
import {authAccount} from '../actions/stripe'
import qs from 'query-string';

class AccountAuthorisation extends Component {

  constructor(props){
    super(props);
    this.state = {}

    //sttripe authorisation Service
    this.authStripeConnectedAccount =  this.props.AuthorisationService.authStripeConnectedAccount.bind(this);
  }

  componentDidMount() {
    var codeParam = null;

    if(this.props.location.search.length > 0 && this.props.location.search !== undefined && this.props.location.search !== null){
      codeParam= qs.parse(this.props.location.search).code ? qs.parse(this.props.location.search).code : null
    }
    if(codeParam !== null) {
      this.authStripeConnectedAccount(codeParam)
    }
  }

  render() {
    return(
      <div className="off-white-bg">
        <div className="container">
          <div className="row no-margin">
            {
              this.props.stripe.authFailed &&
              <div className="col-sm-12">
                <div className="row white-bg cart-container margin-bottom-100 margin-top-100" style={{'fontWeight':'600'}}>
                  <br/>
                  <div className="cart-item-header text-center red-text">
                    Something went wrong. Please repeat the authorisation step to connect to Cotality.
                  </div>
                </div>
              </div>
            }
            {
              this.props.stripe.authSuccess &&
              <div className="col-sm-12">
                <div className="row white-bg cart-container margin-bottom-100 margin-top-100" style={{'fontWeight':'600'}}>
                  <br/>
                  <div className="cart-item-header text-center success-text">
                    Success! You are connected to Cotality.
                  </div>
                </div>
              </div>
            }
            {
              this.props.stripe.authAccountLoader &&
              <div className="row no-margin">
                  <div className="col-sm-12 section-title heading1 text-center" style={{padding:'120px'}}>
                    Authorising your account...
                    <span>
                        <i className="fa fa-spinner fa-pulse fa-fw"></i>
                        <span className="sr-only">Loading...</span>
                      </span>
                  </div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    stripe: state.stripe
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authAccount:(authorisationCode) => dispatch(authAccount(authorisationCode))
  }
}

let AccountAuthorisationPage = connect(mapStateToProps, mapDispatchToProps)(AccountAuthorisation)

export default AccountAuthorisationPage;
